import { menuItemPositionIdName, menuListPositionIdName, menuPopperPositionIdName, } from './constant';
export function getMenuListElement(item) {
    const list = item.parentElement;
    if (list?.hasAttribute(menuListPositionIdName)) {
        return list;
    }
    return null;
}
export function getNextMenuItemElement(item) {
    const id = item.getAttribute(menuItemPositionIdName);
    const list = getMenuListElement(item);
    let nextItem = null;
    if (list && list?.hasAttribute(menuListPositionIdName)) {
        const items = list.querySelectorAll(`*[${menuItemPositionIdName}]`);
        let index = -1;
        for (let i = 0; i < items.length; i++) {
            if (items[i].getAttribute(menuItemPositionIdName) === id) {
                index = i;
                break;
            }
        }
        const targetIndex = (index + 1) % items.length;
        nextItem = items[targetIndex];
    }
    return nextItem;
}
export function getPreviousMenuItemElement(item) {
    const id = item.getAttribute(menuItemPositionIdName);
    const list = getMenuListElement(item);
    let prevItem = null;
    if (list && list?.hasAttribute(menuListPositionIdName)) {
        const items = list.querySelectorAll(`*[${menuItemPositionIdName}]`);
        let index = -1;
        for (let i = 0; i < items.length; i++) {
            if (items[i].getAttribute(menuItemPositionIdName) === id) {
                index = i;
                break;
            }
        }
        const targetIndex = (index - 1 + items.length) % items.length;
        prevItem = items[targetIndex];
    }
    return prevItem;
}
export function getFirstChildMenuItemElement(popper) {
    const popperId = popper?.getAttribute(menuPopperPositionIdName);
    if (!popperId) {
        return null;
    }
    let firstChild = null;
    const items = popper.querySelectorAll(`div > ul > *[${menuItemPositionIdName}]`);
    if (items && items.length > 0) {
        firstChild = items[0];
    }
    // AX: It may be used later to obtain the selected menu item element.
    // if (selectedFirst && firstChild) {
    //   const selectItems = getMenuItemSiblingSelectedElements(firstChild);
    //   firstChild = selectItems[0] ?? firstChild;
    // }
    return firstChild;
}
export function getFirstMenuItemElement(list) {
    let firstItem = null;
    if (list && list?.hasAttribute(menuListPositionIdName)) {
        const items = list.querySelectorAll(`*[${menuItemPositionIdName}]`);
        // istanbul ignore else
        if (items.length > 0 && items[0].hasAttribute(menuItemPositionIdName)) {
            firstItem = items[0];
        }
    }
    return firstItem;
}
export function getLastMenuItemElement(list) {
    let lastItem = null;
    if (list && list?.hasAttribute(menuListPositionIdName)) {
        const items = list.querySelectorAll(`*[${menuItemPositionIdName}]`);
        // istanbul ignore else
        if (items.length > 0 &&
            items[items.length - 1].hasAttribute(menuItemPositionIdName)) {
            lastItem = items[items.length - 1];
        }
    }
    return lastItem;
}
export function getSiblingFirstMenuItemElement(item) {
    const list = getMenuListElement(item);
    let firstItem = null;
    if (list && list?.hasAttribute(menuListPositionIdName)) {
        firstItem = getFirstMenuItemElement(list);
    }
    return firstItem;
}
export function getSiblingLastMenuItemElement(item) {
    const list = getMenuListElement(item);
    let lastItem = null;
    if (list && list?.hasAttribute(menuListPositionIdName)) {
        lastItem = getLastMenuItemElement(list);
    }
    return lastItem;
}
